<template>
  <div>
    <div class="pfsi-component">
      <div class="side-label grid-row-1-2">
        <label> I/We </label>
        <div class="input-box underline">
          <input
            value="Azeus Administrator"
            :readonly="field.metadata.readOnly"
            placeholder=" "
          />
          <div class="input-label">(Name)</div>
        </div>
      </div>
      <div class="input-box grid-row-1-2">
        <input placeholder=" " />
        <div class="input-label" v-if="!field.metadata.hideInlineLabels">
          ID No.
        </div>
      </div>
      <div class="side-label grid-col-1-3 grid-row-2-3">
        <label> of </label>
        <div class="input-box">
          <input placeholder=" " />
          <div class="input-label" v-if="!field.metadata.hideInlineLabels">
            Address
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Bus } from "../main";

export default {
  name: "FormPFSI",
  props: {
    field: {
      type: Object,
    },
  },
  data() {
    return {
      metadata: this.field.metadata,
    };
  },
};
</script>

<style scoped>
.pfsi-component {
  display: grid;
  grid-template-columns: 1fr 1fr;
  text-align: center;
  column-gap: 1rem;
  row-gap: 1.5rem;
}

.side-label {
  display: flex;
  align-items: center;
}

.side-label > label {
  margin-right: 0.5rem;
}

.input-box {
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  overflow: hidden;
  background: #fff;
  padding-left: 0.3rem;
  position: relative;
  overflow: visible;
}

.input-box > input {
  flex-grow: 1;
  font-size: 14px;
  background: #fff;
  border: none;
  outline: none;
  padding: 0.5rem;
  padding-left: 0;
  margin-top: 0.2rem;
  height: 1.5rem;
}

.input-label {
  position: absolute;
  transition: 0.2s;
  pointer-events: none;
  top: 0.65rem;
  font-size: 16px;
  white-space: nowrap;
  background: #fff;
}

.input-box > input:focus ~ .input-label,
.input-box > input:not(:placeholder-shown) ~ .input-label {
  top: -0.5rem;
  color: #0073c3;
  font-size: 13px;
  padding: 0 2px;
}

.input-box:focus-within {
  border: 2px solid #0073c3;
}

.underline {
  border: none;
  border-bottom: 1px solid #222;
  border-radius: 0;
}

.underline:focus-within {
  outline: none;
  border: none;
  border-bottom: 1px solid #000;
}

.grid-col-1-3 {
  grid-column: 1 / 3;
}

.grid-row-1-2 {
  grid-row: 1 / 2;
}

.grid-row-2-3 {
  grid-row: 2 / 3;
}

.required {
  color: #f00;
}
</style>